/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import playImg from '../../assets/icons/play.svg';
import pauseImg from '../../assets/icons/pause.svg';
import repeatImg from '../../assets/icons/repeat.svg';
import plusImg from '../../assets/icons/plus.svg';
import minusImg from '../../assets/icons/minus.svg';
import spinImg from '../../assets/icons/spin.webp';
import styles from './Main.module.css';

// components
import Canvas from '../canvas/Canvas';
import Select from '../buttons/Select';
import ImgBtn from '../buttons/ImgBtn';
import StepSlider from '../buttons/StepSlider';

// code
import data, { uiData } from '../../logic/data';
import { restart, play, step } from '../../logic/process';
import calcFunctions from '../../logic/calc';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  state = {
    exampleIdx: data.exampleIdx,
    playState: 'pause',
    clickDisable: false,
    maxScale: data.examples[0].maxScale,
    initRepeat: data.examples[0].initRepeat,
    step: data.examples[0].step,
    scale: data.examples[0].step,
    busy: false,
    data: {
      data2DFirst: null,
      data2D1: calcFunctions.clearData2D(), // interpolation
      data2D2: calcFunctions.clearData2D(), // repeating
      image: false,
      src: null,
    },
  };

  // after component is rendered
  componentDidMount = () => {
    restart.bind(this)(false);
    setTimeout(() => step.bind(this)(this.state.scale), 0);
  };

  componentWillUnmount = () => {
    clearInterval(this.intervalID);
  };

  getState = () => this.state;

  // change pay/pause state
  // must be arrow because of this
  changePlayState = val => this.setState({ playState: val });

  // play/pause was clicked
  handlePlayClick = () => play.bind(this)();

  // disable/enable play click on transitions
  setPlayClickDisable = val => this.setState({ playClickDisable: val });

  // text button
  handleBtnClick = (idx, val) => {
    this.changePlayState('pause');
    if (val === 'play') {
      setTimeout(() => step.bind(this)(this.state.scale), 0);
    }
  };

  // slider change
  handleSliderChange = val => {
    this.setState({ scale: val });
    setTimeout(step.bind(this, val), 0);
  };

  handleMinusClick = () => {
    let scale = this.state.scale;
    if (scale > 1) {
      scale -= this.state.step;
    }
    this.handleSliderChange(scale);
  };

  handlePlusClick = () => {
    let scale = this.state.scale;
    if (scale < this.state.maxScale) {
      scale += this.state.step;
    }
    this.handleSliderChange(scale);
  };
  // change playing example
  handleExampleChange = val => {
    // console.log('[EXAMPLE]', val);
    this.props.onExampleChange(val);
    let image = false;
    let src = null;
    if (val > 0) {
      image = true;
      src = data.examples[val].src;
    }
    this.setState({
      playState: 'pause',
      exampleIdx: val,
      maxScale: data.examples[val].maxScale,
      initRepeat: data.examples[val].initRepeat,
      step: data.examples[val].step,
      scale: data.examples[val].step,
      data: {
        ...data,
        data2D1: calcFunctions.clearData2D(), // interpolation
        data2D2: calcFunctions.clearData2D(), // repeating
        image: image,
        src: src,
      },
    });
    if (val === 0) {
      setTimeout(() => {
        this.setState({
          scale: data.examples[val].step,
        });
        restart.bind(this)();
        setTimeout(() => step.bind(this)(this.state.scale), 0);
      }, data.examples[val].interval);
    }
  };
  // repeat was clicked
  // handleRepeatClick = () => repeat.bind(this)();
  handleRepeatClick = () => {
    this.handleExampleChange(this.state.exampleIdx);
  };

  handleImgLoad = (dataDraw, width, height) => {
    const data2D1 = calcFunctions.data2DrawConvert2Data2D(
      dataDraw,
      width,
      height
    );
    const data2D2 = calcFunctions.data2DrawConvert2Data2D(
      dataDraw,
      width,
      height
    );
    this.setState(state => ({
      data: {
        ...state.data,
        data2DFirst: data2D1,
        data2D1: data2D1, // interpolation
        data2D2: data2D2, // repeating
      },
    }));

    // after 100ms use image as regular 2D data
    setTimeout(() => {
      this.setState(state => ({
        data: {
          ...state.data,
          image: false,
          src: null,
        },
      }));
    }, 100);
  };

  dummy = () => {};

  // HTML code
  render() {
    const playPauseImg = this.state.playState === 'play' ? pauseImg : playImg;
    let matrix1 = null,
      matrix2 = null;
    if (!this.state.data.image) {
      matrix1 = calcFunctions.data2DConvert2Draw(
        this.state.data.data2D1,
        this.state.initRepeat
      );
      matrix2 = calcFunctions.data2DConvert2Draw(
        this.state.data.data2D2,
        this.state.initRepeat
      );
    }

    return (
      <main className={styles.main}>
        {/* {this.state.busy && <Spinner />} */}
        <div className={styles.frames}>
          <Canvas
            title="bilinear interpolation"
            size={data.size}
            matrix={matrix1}
            image={this.state.data.image}
            src={this.state.data.src}
            onImgLoad={this.handleImgLoad}
          />

          {this.state.busy && (
            <div className={styles.busy}>
              <img src={spinImg} alt=""></img>
              {/* בעבודה */}
            </div>
          )}

          <Canvas
            title="שכפול פיקסלים"
            size={data.size}
            matrix={matrix2}
            image={this.state.data.image}
            src={this.state.data.src}
            onImgLoad={this.dummy}
          />
        </div>
        {/* inputs */}

        <div className={styles.slider}>
          <ImgBtn src={plusImg} onClick={this.handlePlusClick} small={true} />
          <StepSlider
            title="הגדלה"
            onChange={this.handleSliderChange}
            marks
            min={this.state.step}
            max={this.state.maxScale}
            step={this.state.step}
            value={this.state.scale}
            valueLabelDisplay="on"
          />
          <ImgBtn src={minusImg} onClick={this.handleMinusClick} small={true} />
        </div>

        <div className={styles.inputs}>
          <ImgBtn src={playPauseImg} onClick={this.handlePlayClick} />
          <ImgBtn src={repeatImg} onClick={this.handleRepeatClick} />
          {/* <ImgBtn src={stepImg} onClick={this.onStepClick} title="step" /> */}

          {/* {uiData.buttons.map((btn, idx) => {
            let disabled = false;
            return (
              <SimpleBtn
                key={idx}
                obj={btn}
                disabled={disabled}
                onClick={this.handleBtnClick.bind(this, idx)}
              />
            );
          })} */}

          <Select
            options={uiData.selectOptions}
            selectedIdx={this.getState().exampleIdx}
            onSelectChange={this.handleExampleChange}
          />
        </div>
      </main>
    );
  }
}

export default Main;
